import type {
  ScriptsBroadcastRequest,
  ScriptsBroadcastResponse,
} from "@nexus/contracts";

import { authFetch } from "@/lib/api-client";

export type { ScriptsBroadcastRequest, ScriptsBroadcastResponse };

/**
 * A full run (20 scripts × 50 tenants) creates up to 50 sets and publishes up
 * to 1,000 jobs before it answers, which can outlast the 30 s long timeout.
 */
export const SCRIPTS_BROADCAST_TIMEOUT_MS = 120_000;

/**
 * Adge (SUPER_TENANT) only. Creates one set per tenant and starts one adapted
 * copy of each selected script.
 */
export async function broadcastScripts(
  body: ScriptsBroadcastRequest,
): Promise<ScriptsBroadcastResponse> {
  const { data } = await authFetch<ScriptsBroadcastResponse>(
    "/scripts-broadcast",
    {
      method: "POST",
      body: JSON.stringify(body),
      timeoutMs: SCRIPTS_BROADCAST_TIMEOUT_MS,
    },
  );
  if (!data) {
    throw new Error("Scripts broadcast response missing data");
  }
  return data;
}
